import { FC, useState } from 'react';
import Icon from '@common/assets';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useAddBookMark, useDeleteBookMark } from '@repository/job-postings/useJobPostings';
import { CalendarJobPostingItemVO, JobPostingBookmarkType } from '@domain/vo/calendar/CalendarPcListVO';
import Colors from '@domain/constant/colors';

import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './jobPostPopUp.module.scss';
const cx = classnames.bind(styles);

interface PopUpItemProps {
  jobPostingData: CalendarJobPostingItemVO;
  jobPostingBookmarkMap?: JobPostingBookmarkType;
  onClickItem: () => void;
  openLoginModal: () => void;
  handleBookmark: (jobPostingSn: number, newBookmarkStatus: boolean) => void;
}

const PopUpItem: FC<PopUpItemProps> = ({
  jobPostingData,
  jobPostingBookmarkMap,
  onClickItem,
  openLoginModal,
  handleBookmark,
}) => {
  const { sn, name, openingDateTime, closingDateTime } = jobPostingData;
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  //북마크 버튼
  const [bookmark, setBookmark] = useState(jobPostingBookmarkMap?.get(sn) ?? false);
  const { mutateAsync: addBookmark } = useAddBookMark(() => {
    setBookmark(true);
    handleBookmark(sn, true);
  });
  const { mutateAsync: deleteBookmark } = useDeleteBookMark(() => {
    setBookmark(false);
    handleBookmark(sn, false);
  });

  const handleBookmarkBtn = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();

    if (!isLogin) {
      openLoginModal();
      return;
    }

    if (bookmark) deleteBookmark(sn);
    else addBookmark(sn);
  };

  const jobPostDateText = !closingDateTime
    ? '상시채용'
    : `${DateFormat.format(new Date(openingDateTime), 'yyyy.MM.dd(week) HH:mm')} ~ ${DateFormat.format(
        new Date(closingDateTime),
        'yyyy.MM.dd(week) HH:mm',
      )}`;

  return (
    <div className={cx('jobPostList')} onClick={onClickItem}>
      <div className={cx('jobPostInfoArea')}>
        <strong className={cx('jobPostTitle')}>{name}</strong>
        <div className={cx('jobPostDate')}>{jobPostDateText}</div>
      </div>
      <a className={cx('btnBookmark')} role="button" onClick={handleBookmarkBtn}>
        {bookmark ? (
          <Icon name="bookmarkLightFilled" width={24} height={24} fill={Colors.C_GREEN_150} />
        ) : (
          <Icon name="bookmarkLight" width={24} height={24} fill={Colors.C_COOL_GRAY_80} />
        )}
      </a>
    </div>
  );
};

export default PopUpItem;
